import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preconnect to image CDN FIRST for faster resource discovery
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
// Preload hero image (LCP element) — highest priority, before any scripts
const link = document.createElement('link');
link.rel = 'preload';
link.as = 'image';
link.type = 'image/webp';
link.setAttribute('fetchpriority', 'high');
link.setAttribute('imagesizes', '(max-width: 768px) 75vw, 512px');
link.href = 'https://cdn.magicpatterns.com/uploads/3TGnsPowjCqs4XWsH4gxMw/mocap_final_100_citas-removebg-preview_(1).webp';
document.head.appendChild(link);
// Render app immediately
render(<App data-id="element-337" />, document.getElementById('root'));
// UTMify — capture UTMs for attribution (load early, non-blocking)
const utmifyScript = document.createElement('script');
utmifyScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
utmifyScript.async = true;
utmifyScript.defer = true;
utmifyScript.setAttribute('data-utmify-prevent-xcod-sck', '');
utmifyScript.setAttribute('data-utmify-prevent-subids', '');
document.head.appendChild(utmifyScript);
(window as any).pixelId = '6a1525505df1606b61b012cc';
const utmifyPixelScript = document.createElement('script');
utmifyPixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
utmifyPixelScript.async = true;
utmifyPixelScript.defer = true;
document.head.appendChild(utmifyPixelScript);
// Meta Pixel — load immediately so PageView fires reliably
const _w = window as any;
if (!_w.fbq) {
  const fbq: any = _w.fbq = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  if (!_w._fbq) _w._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
}
const fbScript = document.createElement('script');
fbScript.async = true;
fbScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
document.head.appendChild(fbScript);
_w.fbq('init', '996840266444550');
_w.fbq('track', 'PageView');
// Meta Pixel noscript fallback
const fbNoscript = document.createElement('noscript');
const fbImg = document.createElement('img');
fbImg.height = 1;
fbImg.width = 1;
fbImg.style.display = 'none';
fbImg.src = 'https://www.facebook.com/tr?id=996840266444550&ev=PageView&noscript=1';
fbNoscript.appendChild(fbImg);
document.head.appendChild(fbNoscript);